import React from 'react';
import {BaseComponent} from "../../../../project/general";
import {render} from "preact";
import { ToggleButton } from "../../toggle-button"
class TimelineDecadeComponent extends BaseComponent {

    static getRequiredRefs() {
        return ["backgroundTogglePlaceholder"];
    }

    static getNamespace() {
        return 'heritage-timeline-decade';
    }

    background = null;
    decadeSelect = null;
    bgImgToggle = null;
    selectedItem = null;

    cacheDomElements() {
        this.background = document.querySelector("#ah-background-image");
        this.decadeSelect = document.querySelector(".ah-decade-select select");
    }

    showItem(index, items) {
        items.forEach((item, i) => {
            const isActive = i === index;
            item.style.display = isActive ? "flex" : "none";
            if (isActive) {
                this.selectedItem = item;
                this.showOrHideBackgroundImage();
            }
        });
    }

    onScript() {
        console.log(this.refs.data);
        let that = this;
        const items = document.querySelectorAll(".item");
        const buttons = document.querySelectorAll(".decade-button");
        buttons.forEach((button, index) => {
            button.addEventListener("click", function () {
                that.showItem(index, items);
                buttons.forEach(btn => btn.classList.remove("active"));
                button.classList.add("active");
            });
        });

        buttons[0].classList.add("active");

        if (this.decadeSelect) {
            this.decadeSelect.addEventListener("change", (event) => {
                const index = event.target.selectedIndex;
                this.showItem(index, items);
                this.setActiveDecadeButton(index);
            });
        }

        this.showItem(0, items);
        this.renderToggleButton();
    }

    /* Background image toggling */
    renderToggleButton = () => {
        var trueText = this.refs.backgroundTogglePlaceholder.dataset.trueText;
        var falseText = this.refs.backgroundTogglePlaceholder.dataset.falseText;
        render(
            <ToggleButton value={this.backgroundImageIsVisible()}
                onToggle={this.toggleShowBackgroundImage}
                trueText={trueText}
                falseText={falseText}>
            </ToggleButton>,
            this.refs.backgroundTogglePlaceholder
        );
    }

    backgroundImageIsVisible = () => {
        return (localStorage.getItem("showBackgroundImage") == "true");
    }

    toggleShowBackgroundImage = () => {
        var value = !this.backgroundImageIsVisible();
        localStorage.setItem("showBackgroundImage", value);
        this.showOrHideBackgroundImage();
        return value;
    }

    showOrHideBackgroundImage() {
        const input = this.selectedItem.querySelector('input');
        if (input && this.background && this.backgroundImageIsVisible()) {
            this.background.style.backgroundImage = `url(${input.value})`;
        } else {
            this.background.style.backgroundImage = 'none';
        }
    }
    /* End background image toggling */

    onInit() {
        this.cacheDomElements();
        this.onScript();
    }
}

export default TimelineDecadeComponent;
